import React, { useReducer } from 'react'
import NotesContext from './notesContext'
import NotesReducer from './notesReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import { RESPONSE_STATUS, CLEAR_RESPONSE } from './notesTypes'

const NotesState = (props) => {
    const initialState = {
        responseStatus: null,
    }

    const [state, dispatch] = useReducer(NotesReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getNotes = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'getNotes'
            const [res] = await Promise.all([apiCall('post', 'getNotes', formData, '', 'notes')])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const notesAction = async (formData, fromVariable) => {
        try {
            const from = fromVariable ? fromVariable : 'notesAction'
            const [res] = await Promise.all([apiCall('post', 'notesAction', formData, '', 'notes')])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <NotesContext.Provider
            value={{
                responseStatus: state.responseStatus,
                getNotes,
                notesAction,
                clearResponse,
            }}
        >
            {props.children}
        </NotesContext.Provider>
    )
}

export default NotesState
